import React from 'react'
import { ControlLabel, FormControl, FormGroup } from 'rsuite'

export const TextField =  ({ name, label, accepter, inline, ...props }) => {
    return (
        <FormGroup className={inline && 'mb-0'}>
            {label && <ControlLabel>{label} </ControlLabel>}
            <FormControl name={name} accepter={accepter} {...props} />
        </FormGroup>
    )
}





